import { app } from '@/main'
import { nextTick } from 'vue'

import { LogAddToFavorite, LogCriteoAddToCart } from '@/events'

const handleToggle = (adId, toBeFavorized) => {
  const url = toBeFavorized
    ? '/UserPreference/AddFavorite'
    : '/UserPreference/RemoveFavorite'
  const emitOnSuccess = toBeFavorized ? 'favorite-added' : 'favorite-removed'

  app.axios
    .post(
      url,
      JSON.stringify({
        adId: adId,
      })
    )
    .then(resp => {
      if (resp.data.errorCollection && resp.data.errorCollection.length == 0) {
        nextTick(() => {
          app.mitt.emit(emitOnSuccess, adId)

          if (toBeFavorized) {
            LogAddToFavorite()
            LogCriteoAddToCart(adId)
          }
        })
      } else if (
        resp.data.errorCollection &&
        resp.data.errorCollection.length > 0
      ) {
        resp.data.errorCollection.forEach(value => {
          if (value.errorItem === 'authentication') {
            app.toast.info(
              'Du skal være logget ind for at tilføje favoritter. Det er gratis at oprette en profil.',
              () => {
                app.mitt.emit('prompt-login', () => {
                  handleToggle(adId, toBeFavorized)
                })
              },
              'Gå til login',
              'Luk'
            )
          }
          // Returneres 'favorite' er annoncen allerede sat til favorit
        })
      }
    })
}

export { handleToggle }
